import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerSubscription,
  BackendMutationReactivateCustomerSubscriptionArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ReactivateCustomerSubscription($customerId: ID!) {
    reactivateCustomerSubscription(customerId: $customerId) {
      status
    }
  }
`;

type Variables = BackendMutationReactivateCustomerSubscriptionArgs;
type Result = Pick<BackendCustomerSubscription, 'status'>;

export const reactivateCustomerSubscription = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
